import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SelectOption = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  width: 100%;
  padding: 0.5rem 0;
  display: flex;
  background-color: transparent;
  color: ${tokens.text.primary};
  align-items: center;
  padding-left: 1em;
  z-index: 9999999999999 !important;
  transition: 0.13s ease-in;

  &:hover {
    background-color: ${tokens.surface.inset};
    color: ${tokens.text.primary};
    border: none;
  }

  ${(props) =>
    props.disabled &&
    ` opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
      color: ${tokens.text.muted};
      `}
`

export const OptionsContainer = styled.div`
  height: fit-content;
  bottom: 115%;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 9999999999999 !important;
  background-color: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  max-height: 200px;
  overflow-y: auto;
  box-shadow: ${tokens.shadow.card};
`

export const MultiSingle = styled.div`
  height: 100%;
  border-radius: ${tokens.radius.chip};
  background-color: ${tokens.surface.inset};
  padding: 0 7px;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  color: ${tokens.text.primary} !important;

  svg {
    min-width: 15px !important;
    max-height: 15px !important;
    transition: 0.3s ease;
    &:hover {
      transform: scale(1.3);
    }
  }
`

export const SelectInput = styled.input`
  color: ${tokens.text.primary};
  background-color: transparent;

  &::placeholder {
    font-size: 16px;
    color: ${tokens.text.muted};
    line-height: 20px;
    font-weight: 400;
    opacity: 1; /* Firefox applies a lower opacity by default, so set this to 1 for consistency */
  }
`

export const Placeholder = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: ${tokens.text.muted};
  font-weight: 400;
  opacity: 1; /* Firefox applies a lower opacity by default, so set this to 1 for consistency */
`

export const Select = styled.div<{
  invalid?: boolean
  active?: boolean
  value?: boolean
  blured?: boolean
}>`
  width: 100%;
  margin: 0.2rem 0;
  height: 40px;
  color: ${tokens.text.primary};
  border-radius: ${tokens.radius.control};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid
    ${(props) => {
      return props.active
        ? tokens.accent.base
        : !props.invalid && props.value
        ? tokens.border.strong
        : props.invalid && props.blured
        ? tokens.status.danger.fg
        : tokens.border.hairline
    }};
  transition: 0.5s ease;
  padding: 0 1rem;
  font-size: 0.87rem;
  background-color: ${tokens.surface.inset};

  &:hover {
    border: 1px solid ${tokens.border.strong};
  }
`
